<div class="mb-2">
  <label class="form-label"
         for="device-link-location">Location</label>
  <select id="device-link-location"
          class="form-select"
          [ngModel]="selection().locationCategoryId ?? ''"
          (ngModelChange)="locationUpdated($event)">
    <option value=""
            disabled>Select a location</option>
    @for (location of locations(); track location.id) {
      <option [value]="location.id">{{ location.displayName || location.humanId }}</option>
    }
  </select>
</div>
@if (selection().locationCategoryId && !spareOnly()) {
  <fieldset class="mb-2">
    <legend class="fs-6">Assignment</legend>
    <div class="form-check">
      <input id="device-link-spare"
             class="form-check-input"
             type="radio"
             name="assignment-type"
             [checked]="selection().categoryType === 'Location'"
             (change)="typeUpdated('Location')" />
      <label class="form-check-label"
             for="device-link-spare">Spare</label>
    </div>

    @for (group of groups(); track group.type) {
      <div class="form-check">
        <input [id]="'device-link-type-' + group.type"
               class="form-check-input"
               type="radio"
               name="assignment-type"
               [checked]="selection().categoryType === group.type"
               (change)="typeUpdated(group.type)" />
        <label class="form-check-label"
               [for]="'device-link-type-' + group.type">Assign to {{ typeLabel(group.type) }}</label>
      </div>
    } @empty {
      <p>No assignment categories available for this location.</p>
    }
  </fieldset>

  @if (showChildCategoryTarget()) {
    <div class="mb-2">
      <label class="form-label"
             for="device-link-target">{{ typeLabel(selectedGroup()!.type) }}</label>
      <select id="device-link-target"
              class="form-select"
              [ngModel]="selection().categoryId ?? ''"
              (ngModelChange)="targetUpdated($event)">
        <option value=""
                disabled>Select a {{ typeLabel(selectedGroup()!.type) }}</option>
        @for (category of selectedGroup()!.categories; track category.id) {
          <option [value]="category.id">{{ category.displayName || category.humanId }}</option>
        }
      </select>
    </div>
  }
}